import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import LabelledRadio from 'wonderbly-components/lib/LabelledRadio';
import Badge from 'wonderbly-components/lib/Badge';
import { prismicImage } from 'src/common/utils/prismic-image';

import './InterestOption.scss';

const InterestOption = props => (
  <LabelledRadio
    className="interest-option"
    id={props.id}
    value={props.id}
    name={props.optionName}
    checked={props.isSelected}
    onClick={props.onClick}>
    <div className="panel">
      {!isEmpty(props.image) &&
        <img
          className="interest-option-image"
          src={prismicImage(props.image)}
          width={props.image.dimensions.width / 2}
          alt={props.image.alt}
        />
      }
      <span className="interest-option-name">{props.title}</span>
    </div>
    {props.badge && (
      <Badge absolute icon="star">
        {props.badge}
      </Badge>
    )}
  </LabelledRadio>
);

InterestOption.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  badge: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  optionName: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default InterestOption;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Interest/InterestOption/InterestOption.js